<div class="idv-tooltip fade-out">
  @for (table of tables; track $index) {
    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th class="label-col">{{ 'idvTooltip.datapoint' | transloco }}</th>
            @for (source of table.sources; track source.id) {
              <th>{{ getSourceLabel(source.name) }}</th>
            }
          </tr>
          <tr class="status-row">
            <td class="label-col"><strong>{{ 'idvTooltip.sourceStatus' | transloco }}</strong></td>
            @for (source of table.sources; track source.id) {
              <td [class]="getStatusClass(source.status)">{{ source.status | enumLabel:'identityVerificationResult' }}</td>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of table.rows; track row.label) {
            <tr>
              <td class="label-col"><strong>{{ row.label }}</strong></td>
              @for (value of row.values; track $index) {
                <td [innerHTML]="formatCommasForLineBreaks(value)"></td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <span style="padding-top: 8px; display: block;">{{ 'idvTooltip.previewResultsDisplayedAreForFailing' | transloco }}</span>
  <span style="display: block;">{{ 'idvTooltip.seeHubReportForFullDetails' | transloco }}</span>
</div>